import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import { supportUrl } from 'Config/lang';

export default function SupportFAQ({ question, supportArticle }) {
  return (
    <div className="account-table-row-link">
      <div className="account-table-row">
        <div className="account-table-row-content">
          <div className="account-table-details-container">
            {question}
          </div>
          <div className="account-table-action-container">
            <a
              href={`${supportUrl()}/articles/${supportArticle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn account-table-action-button"
            >
              <FormattedMessage id="supportFAQ.link" defaultMessage="View Article" />
              <FontAwesomeIcon icon={faUpRightFromSquare} className="ml-2" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

SupportFAQ.propTypes = {
  question: PropTypes.string,
  supportArticle: PropTypes.string,
};

SupportFAQ.defaultProps = {
  question: '',
  supportArticle: '',
};
